import { ApolloProvider } from '@apollo/react-hooks';
import React, { useEffect } from 'react';
import ReactGA from 'react-ga';
import envConfig from 'src/config/env';
import Routes from './config/routes';
import graphClient from './graphql';
import { useRegions } from './hooks/use-regions';
import { RegionsContext } from './regions-context';
import { GlobalStyle } from './styles/global-style';

const App: React.FC = () => {
  const [regions, setRegions] = useRegions();

  useEffect(() => {
    if (envConfig?.ga?.trackingId) {
      ReactGA.initialize(envConfig.ga.trackingId);
    }
  }, []);

  // Tech Debt: Don't think we even need a context provider as we've got a localStorageHook...

  return (
    <RegionsContext.Provider value={{ regions, setRegions }}>
      <ApolloProvider client={graphClient}>
        <GlobalStyle />
        <Routes />
      </ApolloProvider>
    </RegionsContext.Provider>
  );
};

export default App;
